<template>
  <nav class="bg-brand-gradient text-white shadow-lg">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-16">

        <div class="flex-shrink-0 flex items-center">
          <router-link to="/rfi-dashboard">
            <img class="w-15 h-12 rounded bg-white/90 p-0.5" src="teopm.png" />
          </router-link>
          <span class="ml-2 text-xl font-semibold tracking-wide">RFIs Portal</span>
        </div>


        <div v-if="!isAuthChecking" class="ml-4 flex items-center space-x-4">
          <template v-if="!isAuthenticated">
            <router-link
              to="/login"
              class="px-3 py-2 rounded-md text-sm font-medium hover:bg-white/10 transition-colors"
            >
              Login
            </router-link>
          </template>

          <template v-else>
            <router-link
              to="/rfi-dashboard"
              class="px-3 py-2 rounded-md text-sm font-medium text-white/90 hover:bg-white/10 hover:text-white transition-colors"
              active-class="bg-white/10 text-white"
            >
              Dashboard
            </router-link>
            <router-link
              to="/rfi-management"
              class="px-3 py-2 rounded-md text-sm font-medium text-white/90 hover:bg-white/10 hover:text-white transition-colors"
              active-class="bg-white/10 text-white"
            >
              RFI Management
            </router-link>
            <router-link
              to="/columns-selector"
              class="px-3 py-2 rounded-md text-sm font-medium text-white/90 hover:bg-white/10 hover:text-white transition-colors"
              active-class="bg-white/10 text-white"
            >
              Columns Selector
            </router-link>

            <div class="ml-4 relative">
              <button
                @click="toggleDropdown"
                class="flex items-center space-x-2 focus:outline-none text-white/90 hover:text-white transition-colors"
              >
                <span class="font-medium">{{ userDisplayName }}</span>
                <svg
                  class="h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>

              <div
                v-show="isDropdownOpen"
                class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50 overflow-hidden"
              >
                <div class="py-1" role="none">
                  <router-link
                    v-if="currentUser.is_superadmin == 1"
                    to="/user-permission"
                    class="block px-4 py-2 text-sm hover:bg-brand-50 text-brand-700"
                    @click="isDropdownOpen = false"
                  >
                    Permissions
                  </router-link>

                  <a
                    href="#"
                    @click.prevent="logout"
                    class="block px-4 py-2 text-sm hover:bg-accent-50 text-accent-700"
                  >
                    Log Out
                  </a>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </nav>
</template>

  
  <script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const isDropdownOpen = ref(false);

    const isAuthenticated = !!store.state.users.user;
    const currentUser = store.state.users.user;
    const isAuthChecking = store.state.users.authChecking;

    const userDisplayName = computed(() => {
      return (
        currentUser.first_name + " " + currentUser.last_name ||
        currentUser.email ||
        "User"
      );
    });

    // Methods
    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };

    const logout = async () => {
      try {
        await store.dispatch("logout");
        isDropdownOpen.value = false;
        router.push("/login");
      } catch (error) {
        console.error("Logout error:", error);
      }
    };

    return {
      isDropdownOpen,
      isAuthenticated,
      isAuthChecking,
      userDisplayName,
      toggleDropdown,
      logout,
      currentUser,
    };
  },
};
</script>